'use strict';

module.exports = /* @ngInject */ ["$log", "rediTokenService", function ($log, rediTokenService) {
  function isImpersonating() {
    return rediTokenService.getImpersonator().then(function (impersonator) {
      return !!impersonator;
    });
  }

  return {
    isImpersonating: isImpersonating
  };
}];



//////////////////
// WEBPACK FOOTER
// /app/~/redi-idp-web-lib/dist/business/impersonationService.js
// module id = 119
// module chunks = 0